import React, { FC } from "react";
import { Link } from "react-router-dom";

export interface CheckboxProps {
  label?: string;
  subLabel?: string;
  className?: string;
  nameId: string;
  name: string;
  type: string;
  value?: string;
  defaultChecked?: boolean;
  onChange?: (checked: boolean) => void;
  required?: boolean;
}

const Checkbox: FC<CheckboxProps> = ({
  subLabel = "",
  label = "",
  nameId,
  name,
  className = "",
  value = "1",
  type = "checkout",
  defaultChecked,
  onChange,
  required = false,
}) => {
  return (
    <div className={`flex text-sm sm:text-base ${className}`}>
      <input
        id={nameId}
        name={name}
        type={type}
        className="focus:ring-action-primary h-6 w-6 text-primary-500 border-primary rounded border-neutral-500 bg-white dark:bg-neutral-700 dark:checked:bg-primary-500 focus:ring-primary-500"
        defaultChecked={defaultChecked}
        onChange={(e) => onChange && onChange(e.target.checked)}
        value={value}
        required={required}
      />
      {label && (
        <label
          htmlFor={nameId}
          className="ml-3.5 flex flex-col flex-1 justify-center"
        >
          <span className={`text-neutral-900 dark:text-neutral-100 ${className}`}>
            {(label === 'Terms') ? (
              <>
                By clicking on "Continue CheckOut", you accept the{' '}
                <Link to="/terms-of-use" className="text-primary-500">Terms And Condition</Link>
                , confirm that you will abide by the Safety Tips, and declare that this posting does not include any Prohibited Items.
              </>
            ) : label}
          </span>
          {subLabel && (
            <p className="mt-1 text-neutral-500 dark:text-neutral-400 text-sm font-light">
              {subLabel}
            </p>
          )}
        </label>
      )}
    </div>
  );
};

export default Checkbox;
